import script from "./PbxDevicesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PbxDevicesPanel.vue?vue&type=script&setup=true&lang=js"

import "./PbxDevicesPanel.vue?vue&type=style&index=0&id=761c6c24&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-761c6c24"]])

export default __exports__